
import { Vue, Options } from 'vue-class-component'
import { getUrlModalOptionsMyCoupon, modalOptionsCouponLotus } from '@/model/modal-options.model'
import { useStore } from '@/store'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper-bundle.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import { MyCoupon } from '@/model/my-coupon.model'
import { mappingImageDefault } from '@/helpers/mapper'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { OffersList } from '@/interfaces/my-coupon'

library.add(faChevronRight)

@Options({
  components: {
    Swiper,
    SwiperSlide,
    FontAwesomeIcon,
    QSkeleton
  },
  computed: {
    isLoading() {
      return this.$store.state.myCouponInfo.premiumOffers.isLoading
    },
    offersList() {
      return this.$store.state.myCouponInfo.premiumOffers.items
    }
  }
})
export default class PremiumReward extends Vue {
  store = useStore()
  modules = [FreeMode]
  textTitleName = MyCoupon.COUPON_PREMIUM_TITLE
  textViewAll = MyCoupon.VIEW_ALL

  getImage(image: string) {
    return mappingImageDefault(image)
  }

  errorImage(event: any) {
    event.target.onerror = null
    event.target.src = require('../../assets/img/coupon-image-placeholder.png')
    event.target.className = 'premium-reward-detail-img-default'
  }

  openModalOffer(offer: OffersList) {
    const myCouponToken = this.store.state.lineInfo.idToken
    const customerType = this.store.state.customer?.customerType ?? undefined
    const url = getUrlModalOptionsMyCoupon(offer?.id, 'lotus', 'offer', 'discount', customerType, undefined)
    modalOptionsCouponLotus.url = `${url}${offer?.id ? '&action=back-to-line-web' : ''}&token=${myCouponToken}`
    
    this.store.commit('modalIframe/updateModalIframeActive', true)
    this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponLotus)
    this.updateGAEvent(offer)
  }

  updateGAEvent(offer: OffersList) {
    const customerType = this.store.state.customer?.customerType
    let objEvent = {}
    if (offer?.id) {
      objEvent = {
        event: 'mylotuss_coupon_card',
        topic_section: 'premium_coupon_lotus',
        component: 'premium-reward-slide',
        coupon_section: offer?.offerDetails?.title,
        coupon_type: offer?.offerDetails?.offerType,
        coupon_scope: customerType
      }
    } else {
      objEvent = {
        event: 'mylotuss_see_all',
        topic_section: 'premium_coupon_lotus',
        component: 'premium-reward-title-view-all'
      }
    }
    addGAEvent(objEvent)
  }
}
